import React from 'react';
import PropTypes from 'prop-types';
import { Button, Grid, Typography } from '@material-ui/core';
import { useIntl } from 'react-intl';

const HeadSubHeadWrapper = props => {
  const { overviewTitle, subTitle, addButtonHandler, showAddButton, buttonTitle, addButtonPrefix, showCloneButton, cloneButtonHandler, cloneButtonTitle } = props;
  const intl = useIntl();

  const buttonPrefix = addButtonPrefix || intl.formatMessage({id: "app.general.add", defaultMessage: "Add"} );

  return (
    <Grid container justify="space-between" spacing={3}>
      <Grid item xs={8}>
        <Typography component="h2" gutterBottom variant="overline">
          {overviewTitle}
        </Typography>
        <Typography component="h1" variant="h3">
          {subTitle}
        </Typography>
      </Grid>
      {showCloneButton ? (
        <Grid item xs={2}>
          <Button color="primary" onClick={cloneButtonHandler} variant="contained">
            {cloneButtonTitle}
          </Button>
        </Grid>
      ) : null}
      {showAddButton ? (
        <Grid item xs={2}>
          <Button color="primary" onClick={addButtonHandler} variant="contained">
            {buttonPrefix} {buttonTitle || subTitle}
          </Button>
        </Grid>
      ) : null}
    </Grid>
  );
};

HeadSubHeadWrapper.propTypes = {
  overviewTitle: PropTypes.any,
  subTitle: PropTypes.any,
  addButtonHandler: PropTypes.func,
  showAddButton: PropTypes.bool,
  buttonTitle: PropTypes.string,
  addButtonPrefix: PropTypes.string,
  showCloneButton: PropTypes.bool,
  cloneButtonHandler: PropTypes.func,
  cloneButtonTitle: PropTypes.string
};

HeadSubHeadWrapper.defaultProps = {
  overviewTitle: 'Management',
  subTitle: 'Devices',
  addButtonHandler: () => null,
  showAddButton: true,
  showCloneButton: false,
  cloneButtonHandler: () => null,
  cloneButtonTitle: ""
};

export default HeadSubHeadWrapper;
